/* @flow */

import * as React from 'react';
import styled from 'styled-components';

import { Button, Footer } from '@sonyged/ext-proc';
import { Flex, Text } from '@sonyged/proc-ui';
import css from '@styled-system/css';

import { Pizza } from '../../pizza/fields/domain/pizza';
import { Stars } from './Stars';
import { ingredientName } from './constants';
import AutoScaleContainer from '../../pizza/fields/AutoScaleContainer';
import PizzaContainer from '../../pizza/fields/PizzaContainer';

type Props = {
  onNext: void => void,
  fromStats?: boolean,
  yesterdayPizza: Pizza,
  todayPizza: Pizza,
  customerCount: number,
  sale: number,
  star: number,
};

class PizzaResultView extends React.Component<Props> {
  renderResultSale() {
    const { customerCount, sale } = this.props;

    return (
      <table className="proc-table">
        <thead>
          <tr>
            <th className={'left-aligned'}>お金</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <PriceLayout>
                <Content>
                  <Tile>売れた数</Tile>
                </Content>
                <ContentInfo>
                  <NumberText>{customerCount}</NumberText>
                  <NumberInfo>まい</NumberInfo>
                </ContentInfo>
              </PriceLayout>
              <PriceLayout>
                <Content>
                  <Tile>ピザのねだん</Tile>
                </Content>
                <ContentInfo>
                  <NumberText>700</NumberText>
                  <NumberInfo>円</NumberInfo>
                </ContentInfo>
              </PriceLayout>
              <Hr />
              <MoneyReceivedLayout>
                <MoneyReceivedContent>
                  <MoneyReceivedText>売り上げ</MoneyReceivedText>
                </MoneyReceivedContent>
                <ContentInfo>
                  <MoneyReceivedNumber>{sale}</MoneyReceivedNumber>
                  <NumberInfo>円</NumberInfo>
                </ContentInfo>
              </MoneyReceivedLayout>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  renderRatings() {
    const { star } = this.props;

    return (
      <table className="proc-table">
        <thead>
          <tr>
            <th className={'left-aligned'}>ひょうか</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Flex>
                <Content>
                  <Tile>お店のひょうか</Tile>
                </Content>
                <ContentInfo>
                  <div className="proc-result-rate-star">
                    <Stars stars={star} />
                  </div>
                </ContentInfo>
              </Flex>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  renderPizzaCompare() {
    const { yesterdayPizza, todayPizza } = this.props;

    return (
      <table className="proc-table">
        <thead>
          <tr>
            <th className={'left-aligned'}>前日のピザ</th>
            <th className={'left-aligned'}>本日のピザ</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ verticalAlign: 'top' }}>
              <ProcResultSalePizza>
                <AutoScaleContainer preferedHeight={600} preferedWidth={1080} preferedMinWidth={1080}>
                  <PizzaContainer pizza={yesterdayPizza} />
                </AutoScaleContainer>
              </ProcResultSalePizza>
              <div className="ingredients-container proc-small-font">
                {[yesterdayPizza.crust, yesterdayPizza.sauce].concat(yesterdayPizza.toppings).map((ingredient, i) => (
                  <div key={i}>{ingredientName(ingredient)}</div>
                ))}
              </div>
            </td>
            <td style={{ verticalAlign: 'top' }}>
              <ProcResultSalePizza>
                <AutoScaleContainer preferedHeight={600} preferedWidth={1080} preferedMinWidth={1080}>
                  <PizzaContainer pizza={todayPizza} />
                </AutoScaleContainer>
              </ProcResultSalePizza>
              <div className="ingredients-container proc-small-font">
                {[todayPizza.crust, todayPizza.sauce].concat(todayPizza.toppings).map((ingredient, i) => (
                  <div key={i}>{ingredientName(ingredient)}</div>
                ))}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <div className={`pizza-inner-view pizza-result-view tertiary100-bg-color`}>
        <div className={`proc-contents padding`}>
          <div className="proc-outer">
            <div className="proc-inner">
              <div className="content">
                {this.renderResultSale()}
                {this.renderRatings()}
                {this.renderPizzaCompare()}
              </div>
            </div>
          </div>
        </div>
        {this.renderFooter()}
      </div>
    );
  }

  renderFooter() {
    return <Footer.normal className="white-bg-color">{this.renderNextButton()}</Footer.normal>;
  }

  renderNextButton() {
    const { fromStats = false } = this.props;
    if (fromStats) {
      return <Button.normal onClick={this.onNextClick.bind(this)}>もどる</Button.normal>;
    }
    return <Button.attention onClick={this.onNextClick.bind(this)}>つぎへ</Button.attention>;
  }

  onNextClick() {
    this.props.onNext();
  }
}

export default PizzaResultView;

const PriceLayout = styled(Flex)(
  css({
    mb: ['12px', '12px', '18px'],
  })
);

const MoneyReceivedLayout = styled(Flex)(
  css({
    mt: ['16px', '16px', '28px'],
  })
);

const Tile = styled(Text)(
  css({
    display: 'block',
    bg: 'gray10',
    p: '5px 10px',
    fontSize: ['14px', '14px', '20px'],
  })
);

const Content = styled('div')(
  css({
    width: '50%',
  })
);

const ContentInfo = styled(Flex)(
  css({
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '50%',
  })
);

const NumberText = styled(Text)(
  css({
    fontSize: ['20px', '20px', '32px'],
  })
);

const NumberInfo = styled(Text)(
  css({
    fontSize: ['14px', '14px', '20px'],
  })
);

const MoneyReceivedText = styled(Text)(
  css({
    fontSize: ['16px', '16px', '22px'],
    color: 'secondary100',
  })
);

const MoneyReceivedNumber = styled(Text)(
  css({
    fontSize: ['30px', '30px', '40px'],
  })
);

const MoneyReceivedContent = styled(Flex)(
  css({
    width: '50%',
    alignItems: 'center',
  })
);

const Hr = styled('div')(
  css({
    width: '100%',
    height: '1px',
    bg: 'secondary30',
  })
);

const ProcResultSalePizza = styled('div')(
  css({
    '.pizza-viewport-inner': {
      position: 'relative !important',
    },
    '.pizza-image.pizza-container': {
      top: 0,
      width: '100%',
      height: '100%',
    },
  })
);
